import React, { useEffect, useRef, useState } from 'react';
import { Box, TextInput } from 'grommet';
import { authorizedFetch } from '../../utils';
import { getSuggestionItem } from '../../items/items';
import TagItem from '../tag-item';

// Convert vertical data to a format that can be used by the selector
export const transformVerticalsData = input => {
  const output = [];
  input.forEach(vertical => {
    output.push({
      id: vertical.id,
      verticalName: vertical.name
    });

    vertical.subVerticals.forEach(subVertical => {
      output.push({
        id: subVertical.id,
        verticalName: `${vertical.name}: ${subVertical.name}`
      });
    });
  });
  return output;
};

const VerticalSubverticalSelector = ({
  verticalIds,
  setVerticalIds,
  addError
}) => {
  const textRef = useRef();
  const [value, setValue] = useState('');
  const [itemNames, setItemNames] = useState([]);
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    // Fetch vertical data
    authorizedFetch(`/api/vertical/getAll`)
      .then(response => {
        const data = transformVerticalsData(response);
        const result = data.reduce((acc, item) => {
          acc[item.id] = item.verticalName;
          return acc;
        }, {});
        setItemNames(result);
      })
      .catch(e => addError('Error lookup Vertical data', e.message));
  }, []);

  useEffect(() => {
    // Filter suggestions based on user input
    setSuggestions(
      Object.keys(itemNames)
        .filter(
          id =>
            verticalIds.indexOf(id) === -1 &&
            itemNames[id].toLowerCase().indexOf(value.toLowerCase()) !== -1
        )
        .map(id => getSuggestionItem({ id, name: itemNames[id] }))
    );
  }, [value, itemNames, verticalIds]);

  return (
    <Box flex={{ grow: 1 }}>
      <Box direction='row' border={{ color: 'border500' }} round='xsmall'>
        <Box
          direction='row'
          wrap={true}
          style={{ maxWidth: '65%' }}
          align='center'
          flex={{ shrink: 0 }}
        >
          {verticalIds.map(id => (
            <TagItem
              size='medium'
              key={id}
              tag={itemNames[id] || id}
              canEdit={true}
              onRemoveClick={id => {
                const newVerticalIds = [...verticalIds];
                newVerticalIds.splice(newVerticalIds.indexOf(id), 1);
                setVerticalIds(newVerticalIds);
              }}
            />
          ))}
        </Box>
        <Box flex={true}>
          <TextInput
            size='medium'
            placeholder='Add Vertical : Subvertical'
            plain
            disabled={false}
            ref={textRef}
            value={value}
            onChange={e => setValue(e.target.value)}
            suggestions={suggestions}
            onSelect={e => {
              const { id, name } = e.suggestion.value;
              // Add selected vertical/subvertical to the list
              const newVerticalIds = [...verticalIds];
              newVerticalIds.push(id);
              setVerticalIds(newVerticalIds);
              // Update the item names
              const newItemNames = { ...itemNames };
              newItemNames[id] = name;
              setItemNames(newItemNames);
              // Clear the input field
              setValue('');
              // Focus on the input field
              textRef.current.focus();
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

VerticalSubverticalSelector.displayName = 'VerticalSubverticalSelector';

export default VerticalSubverticalSelector;
